import './lib/i18n';

import { ApiClientProvider } from '@bonboca/queries';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { getApiClient } from './lib/api';
import { configureAuth } from './lib/auth';
import { CartProvider } from './lib/cart';
import { router } from './router';
import './styles/index.css';

configureAuth();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root container not found');

createRoot(container).render(
  <StrictMode>
    <Suspense>
      <QueryClientProvider client={queryClient}>
        <ApiClientProvider client={getApiClient()}>
          <CartProvider>
            <RouterProvider router={router} />
          </CartProvider>
        </ApiClientProvider>
      </QueryClientProvider>
    </Suspense>
  </StrictMode>,
);
